<template>
  <div v-clickout class="game-select" @clickout="selecting = false">
    <div
      class="drop-downA"
      :class="{ selecting: selecting }"
      @click="selecting = !selecting"
    >
      <div class="drop-down-sel ellipsis-1">
        {{ curGame.title || placeholder }}
      </div>
    </div>
    <div v-show="selecting" class="game-select__board">
      <slot :item-click="itemClick">
        <div class="tabs">
          <template v-if="showLastPlayed">
            <span :class="{ cur: cur === -1 }" @click="cur = -1">最近玩过</span>
            <i :key="'i-0'" class="divider"></i>
          </template>
          <template v-for="(item, i) in letters">
            <span
              :key="'s-' + item"
              :class="{ cur: cur === i }"
              @click="cur = i"
              >{{ item }}</span
            >
            <i :key="'i-' + item" class="divider"></i>
          </template>
        </div>
        <div v-if="cur === -1 && showLastPlayed" class="board-box">
          <div class="game-select__board-line">
            <div class="item-wrap">
              <span
                v-for="item in playedGames"
                :key="item.game_id"
                class="item"
                @click="itemClick(item)"
              >
                <span
                  class="ellipsis-1"
                  :class="{ cur: curGame.game_id === item.game_id }"
                  >{{ item.title }}</span
                >
              </span>
            </div>
          </div>
        </div>
        <div v-else class="board-box">
          <div
            v-for="(arr, key) in curLetters"
            :key="key"
            class="game-select__board-line"
          >
            <span class="letter">{{ key }}</span>
            <div class="item-wrap">
              <span
                v-for="item in arr"
                :key="item.game_id"
                class="item"
                @click="itemClick(item)"
              >
                <span
                  class="ellipsis-1"
                  :class="{ cur: curGame.game_id === item.game_id }"
                  >{{ item.title }}</span
                >
              </span>
            </div>
          </div>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
import { clickout } from '~/plugins/vue-clickout'
export default {
  directives: {
    clickout
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String
    },
    curGame: {
      type: Object,
      default: () => ({})
    },
    playedGames: {
      type: Array,
      default: () => []
    },
    showLastPlayed: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      selecting: false,
      cur: this.showLastPlayed ? -1 : 0,
      letters: ['ABCDE', 'GFHIJ', 'KLMNO', 'PQRSRT', 'UVWXYZ']
    }
  },
  computed: {
    curLetters() {
      return [...this.letters[this.cur]].reduce((p, c) => {
        if (this.gameMap[c] && this.gameMap[c].length) {
          p[c] = this.gameMap[c]
        }
        return p
      }, {})
    },
    gameMap() {
      return this.list.reduce((p, c) => {
        const letter = c.game_initial[0].toUpperCase()
        p[letter] ? p[letter].push(c) : (p[letter] = [c])
        return p
      }, {})
    }
  },
  methods: {
    itemClick(item) {
      this.$emit('change', item)
      this.selecting = false
    }
  }
}
</script>

<style lang="scss">
.game-select {
  position: relative;
  display: inline-block;
  text-align: left;
  * {
    box-sizing: border-box;
  }
  &__board {
    position: absolute;
    z-index: 1;
    top: 48px;
    left: 0;
    width: 512px;
    height: 290px;
    background-color: #ffffff;
    box-shadow: 0px 0px 8px 0px rgba(183, 188, 206, 0.75);
    border-radius: 4px;
    border: solid 1px #c4d2f2;
    padding: 19px 10px;
    font-size: 14px;
    .tabs {
      color: #a4acbe;
      span {
        cursor: pointer;
      }
      .cur {
        color: #508aff;
        font-weight: bold;
      }
    }
    .board-box {
      margin-top: 26px;
      height: 200px;
      overflow: auto;
      overscroll-behavior: none;
      &::-webkit-scrollbar {
        width: 4px;
        height: 80px;
        background-color: #ffffff;
      }

      &::-webkit-scrollbar-track {
        border-radius: 10px;
        background-color: #ffffff;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: #d0e0ff;
      }
      &::-webkit-scrollbar-thumb:hover {
        background-color: #508aff;
      }
    }
    &-line {
      min-height: 30px;
      line-height: 30px;
      margin-bottom: 10px;
    }
    .item-wrap {
      display: inline-block;
      width: 454px;
    }
    .item {
      display: inline-block;
      height: 100%;
      color: #3e3e52;
      width: 110px;
      span {
        display: inline-block;
        padding: 0 10px;
        box-sizing: border-box;
        max-width: 100%;
        vertical-align: bottom;
        cursor: pointer;
        &:hover {
          background-color: #eef4ff;
        }
        &.cur {
          background-color: #eef4ff;
        }
      }
    }
    .single-item {
      height: 30px;
      line-height: 30px;
      margin-bottom: 10px;
    }
    .letter {
      color: #508aff;
      margin-right: 9px;
      vertical-align: top;
    }
  }
}
</style>
